import Swiper from 'swiper/bundle';

class SliderPosts {
    constructor() {
        this.components = document.querySelectorAll('.m-slider-posts');

        this.components.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const swiper = component.querySelector('.swiper');

        new Swiper(swiper, {
            autoHeight: true,
            navigation: {
                nextEl: '.m-slider-posts__next',
                prevEl: '.m-slider-posts__prev',
            },
            slidesPerView: 1,
            speed: 750,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                960: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
    }
}

export default SliderPosts;
